import { render, staticRenderFns } from "./TaskChangeChecklist.vue?vue&type=template&id=29137e6a&scoped=true&lang=pug&"
import script from "./TaskChangeChecklist.vue?vue&type=script&lang=js&"
export * from "./TaskChangeChecklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29137e6a",
  null
  
)

export default component.exports